import "./styles.css"

export function Footer() {
  return (
    <footer data-id="site-footer">
      <p>© PLAYBRAIN Inc All Rights Reserved</p>
    </footer>
  )
}

export default Footer
